export const params = {
    state: {
        chrono: [
            {chronoId: 10, chronoDesc: "Standard"},
            {chronoId: 20, chronoDesc: "Plus"},
            { chronoId: 50, chronoDesc: "SKG**" },
            {chronoId: 40, chronoDesc: "RC2"},
            { chronoId: 60, chronoDesc: "RC3" },
            {chronoId: 80, chronoDesc: "Hurricane"},
            {chronoId: 90, chronoDesc: "Fireproof"}
        ],
        hinge: [
            {hingeId: 1, hingeDesc: "winlist_VisibleHinges", hingePng: "/src/assets/35140_760_1.png"},
            {hingeId: 2, hingeDesc: "winlist_PRO", hingePng: "/src/assets/32114_780.png"},
            {hingeId: 4, hingeDesc: "winlist_VisibleNAHinges", hingePng: "/src/assets/35140_760_1.png"},
            {hingeId: 5, hingeDesc: "winlist_GO", hingePng: "/src/assets/32107_780_1.png"}
        ],
        type: [
            {typeId: 1, sysco: 0, typeDesc: "addwin_TurnTilt"},
            {typeId: 2, sysco: 0, typeDesc: "addwin_TurnTiltFC"},
            {typeId: 3, sysco: 0, typeDesc: "addwin_TiltTurn"},
            {typeId: 4, sysco: 0, typeDesc: "addwin_TiltTurnFC"},
            {typeId: 6, sysco: 0, typeDesc: "addwin_SideHung"},
            {typeId: 60, sysco: 0, typeDesc: "addwin_SideHungFC"},
            {typeId: 7, sysco: 0, typeDesc: "addwin_VBottomHung"},
            {typeId: 8, sysco: 0, typeDesc: "addwin_HBottomHung"},
            {typeId: 30, sysco: 0, typeDesc: "addwin_OpenOut"},
            {typeId: 31, sysco: 0, typeDesc: "addwin_OpenOutFrenchCasement"},
            {typeId: 16, sysco: 0, typeDesc: "addwin_VentilationVent" },
            {typeId: 21, sysco: 0, typeDesc: "addwin_BalconyTUTI"},
            {typeId: 22, sysco: 0, typeDesc: "addwin_BalconyTUTIFC"},
            {typeId: 23, sysco: 0, typeDesc: "addwin_BalconyTITU"},
            {typeId: 26, sysco: 0, typeDesc: "addwin_BalconySIHU"},
            {typeId: 27, sysco: 0, typeDesc: "addwin_BalconySIHUFC"},
            {typeId: 46, sysco: 0, typeDesc: "addwin_HandleAtCill"},
            {typeId: 55, sysco: 0, typeDesc: "addwin_EInvisitop" },
        ],
        handle: [
            {handleId: 1, handleDesc: "winlist_ForkHandle"},
            {handleId: 3, handleDesc: "winlist_SquareSpindleHandle"},
            {handleId: 4, handleDesc: "winlist_BaselessHandle"},
            {handleId: 5, handleDesc: "winlist_SpecialSquareHandle"}
        ],
        opdir: [
            {openId: 1, openDesc: "R"},
            {openId: 2, openDesc: "L"}
        ],
        groove: [
            {grooveId: 10, grooveDesc: "10-14"},
            {grooveId: 14, grooveDesc: "14-18"}
        ],
        color: [
            {code: "C1", desc: "addwin_C1"},
            {code: "C3", desc: "addwin_C3"},
            {code: "C4", desc: "addwin_C4"},
            {code: "C5", desc: "addwin_C5"},
            {code: "C6", desc: "addwin_C6"},
            {code: "CN", desc: "addwin_CN"},
        ],
        screw: ["6", "12", "16"],
        sysco: [
            {code: "1", desc: "SOB"},
            {code: "2", desc: "REY"},
            {code: "4", desc: "VBH"},
            {code: "5", desc: "ALK"},
            {code: "6", desc: "SMT"},
            {code: "7", desc: "SAP"},
            {code: "8", desc: "TIT"},
            {code: "9", desc: "ALI"},
        ],
        cyl880: [
            {b: 30, c:30},
            {b: 30, c:35},
            {b: 30, c:40},
            {b: 30, c:45},
            {b: 30, c:50},
            {b: 30, c:55},
            {b: 30, c:60},
            {b: 30, c:65},
            {b: 30, c:70},
            {b: 30, c:75},
            {b: 30, c:80},
            {b: 30, c:90},
            {b: 35, c:35},
            {b: 35, c:40},
            {b: 35, c:45},
            {b: 35, c:50},
            {b: 35, c:55},
            {b: 35, c:60},
            {b: 35, c:65},
            {b: 35, c:70},
            {b: 35, c:75},
            {b: 35, c:80},
            {b: 35, c:85},
            {b: 40, c:40},
            {b: 40, c:45},
            {b: 40, c:50},
            {b: 40, c:55},
            {b: 40, c:60},
            {b: 40, c:65},
            {b: 40, c:70},
            {b: 40, c:75},
            {b: 40, c:80},
            {b: 40, c:85},
            {b: 40, c:90},
            {b: 45, c:45},
            {b: 45, c:50},
            {b: 45, c:55},
            {b: 45, c:60},
            {b: 45, c:65},
            {b: 50, c:50},
            {b: 50, c:55},
            {b: 50, c:60},
            {b: 50, c:65},
            {b: 60, c:60}
        ],
        cyl880b: [30, 35, 40, 45, 50, 60]
    },
    getters: {
        getChrono: (state) => {
            return state.chrono;
        },
        getHinge: (state) => {
            return state.hinge;
        },
        getHandle: (state) => {
            return state.handle;
        },
        getMotor: (state) => {
            return state.motor;
        },
        getColor: (state) => {
            return state.color;
        },
        getScrew: (state) => {
            return state.screw;
        },
        getOpDir: (state) => {
            return state.opdir;
        },
        getGroove: (state) => {
            return state.groove;
        },
        getSysco: (state) => {
            return state.sysco;
        },
        getErrorList: (state) => {
            return state.errorlist;
        },
        getcyl880b: (state) => {
            return state.cyl880b
        },
        getcyl880: (state) => {
            return state.cyl880
        }
    }
}



// WEBPACK FOOTER //
// ./src/ClientApp/store/params.js